/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This signifies what the number in the 'durationAmount' field is.
 * @export
 */
export const DurationUnit = {
    HOUR: 'HOUR',
    DAY: 'DAY'
} as const;
export type DurationUnit = typeof DurationUnit[keyof typeof DurationUnit];


export function instanceOfDurationUnit(value: any): boolean {
    for (const key in DurationUnit) {
        if (Object.prototype.hasOwnProperty.call(DurationUnit, key)) {
            if (DurationUnit[key as keyof typeof DurationUnit] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DurationUnitFromJSON(json: any): DurationUnit {
    return DurationUnitFromJSONTyped(json, false);
}

export function DurationUnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationUnit {
    return json as DurationUnit;
}

export function DurationUnitToJSON(value?: DurationUnit | null): any {
    return value as any;
}

export function DurationUnitToJSONTyped(value: any, ignoreDiscriminator: boolean): DurationUnit {
    return value as DurationUnit;
}

